import { Flame, Leaf, Clock, Sparkles, HeartHandshake, Users } from "lucide-react";
import { FadeUp, SectionHead } from "./Motion";

const FEATURES = [
  { n: "130+", label: "Menu Items", icon: Sparkles, desc: "The largest South Indian menu in Edison" },
  { n: "02", label: "Fresh Ingredients", icon: Leaf, desc: "Ground, fermented & cooked fresh daily" },
  { n: "03", label: "Authentic Taste", icon: Flame, desc: "True recipes from South Indian kitchens" },
  { n: "04", label: "Fast Service", icon: Clock, desc: "Express by name, express by nature" },
  { n: "05", label: "Premium Catering", icon: HeartHandshake, desc: "From 20 guests to 500" },
  { n: "06", label: "Family Friendly", icon: Users, desc: "A table for every generation" },
];

const Features = () => (
  <section data-testid="features-section" className="mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
    <SectionHead
      index="04"
      kicker="Why Sri Dosa Express"
      title={<>The details that <em className="italic text-gold">define us</em></>}
    />
    <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
      {FEATURES.map((f, i) => (
        <FadeUp key={f.label} delay={(i % 3) * 0.1} className="bg-ink">
          <div
            data-testid={`feature-${f.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="group flex h-full flex-col justify-between gap-10 p-8 transition-colors duration-500 hover:bg-surface md:p-10"
          >
            <div className="flex items-start justify-between">
              <f.icon size={22} className="text-gold" strokeWidth={1.5} />
              <span className="font-serif text-5xl text-white/12 transition-colors duration-500 group-hover:text-gold/40">{f.n}</span>
            </div>
            <div>
              <h3 className="font-serif text-2xl text-white">{f.label}</h3>
              <p className="mt-2 text-sm text-mist">{f.desc}</p>
            </div>
          </div>
        </FadeUp>
      ))}
    </div>
  </section>
);

export default Features;
